import {} from '@polkadot/api';
import { useContext } from 'react';
import { atomFamily, constSelector, isRecoilValue } from 'recoil';
import {} from 'rxjs';
import { ApiIdContext, RecoilStateContext } from './Context.js';
import { garbageCollectionKey } from './GarbageCollector.js';
export const queryMultiAtomFamily = (options) => {
    const _state = atomFamily({
        key: 'ChainQueryMulti',
        effects: ({ apiId, queries }) => [
            ({ setSelf, getPromise }) => {
                let initialResolve = (_value) => { };
                let initialReject = (_reason) => { };
                setSelf(new Promise((resolve, reject) => {
                    initialResolve = resolve;
                    initialReject = reject;
                }));
                const maybeApi = options.getApi(apiId);
                const apiPromise = (async () => {
                    if (isRecoilValue(maybeApi)) {
                        return await getPromise(maybeApi);
                    }
                    if ('then' in maybeApi) {
                        return await maybeApi;
                    }
                    return maybeApi;
                })();
                const unsubscribePromise = apiPromise.then(async (api) => {
                    const params = queries.map(x => {
                        if (typeof x === 'string') {
                            const [module, section] = x.split('.');
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            return api.query[module]?.[section];
                        }
                        const [query, ...params] = x;
                        const [module, section] = query.split('.');
                        return [api.query[module]?.[section], ...params];
                    });
                    return await api
                        .queryMulti(params, result => {
                        initialResolve(result);
                        setSelf(result);
                    })
                        .catch((error) => {
                        initialReject(error);
                    });
                });
                return () => {
                    void unsubscribePromise.then(unsubscribe => {
                        if (typeof unsubscribe === 'function') {
                            unsubscribe();
                        }
                    });
                };
            },
        ],
        dangerouslyAllowMutability: true,
    });
    return Object.assign((apiId, queries) => _state({ apiId, queries }), { [garbageCollectionKey]: options.key });
};
export const useQueryMultiState = (queries, options = { enabled: true }) => {
    if (!options.enabled) {
        return constSelector(undefined);
    }
    return useContext(RecoilStateContext).queryMultiState(useContext(ApiIdContext), queries);
};
//# sourceMappingURL=queryMulti.js.map